import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { MessageEditedSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'
import { useAuthStore } from 'src/common/store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.messageEdited,
  (text, response) => {
    const payload: MessageEditedSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    const authStore = useAuthStore()
    if (
      response.CenterId &&
      response.CenterId !== authStore.currentCenterId &&
      !authStore.isClient
    ) {
      return
    }
    messagingServiceStore.handleMessageEditedEvent(payload)
  },
)
